<template>
  <div class="cross-icon" @click="crossClicked" />
</template>
<script>
export default {
  name: 'CrossIcon',
  methods: {
    crossClicked () {
      this.$emit('crossClicked')
    }
  }
}
</script>
<style lang="scss" scoped>
.cross-icon {
  position: fixed;
  width: 20px;
  height: 20px;
  cursor: pointer;
  right: 26px;
  top: 33px;
  z-index: 99999999;

  @media(min-width: $screen-md) {
      top: 118px;
  }

  &:before, &:after {
    position: absolute;
    left: 15px;
    content: ' ';
    height: 28px;
    width: 1px;
    background-color: #000;
  }
  &:before {
    transform: rotate(45deg);
  }
  &:after {
    transform: rotate(-45deg);
  }

}

</style>
